import React, { useRef, useState } from "react";
import styles from "@/components/pages/home/components/searchbar/styles/dropdown.module.scss";
import Image from "next/image";
import closeIcon from "@/assets/icons/close-icon-yellow.svg";
import arrowUp from "@/assets/icons/arrow-up-yellow.svg";
import arrowDown from "@/assets/icons/arrow-down-yellow.svg";
import { useDropdownMenuWithOutsideClosing } from "@/hooks/use-dropdown-menu-with-outside-closing";
import { createPortal } from "react-dom";

export interface DropdownSelectorOption {
  id: string;
  title: string;
  category: string;
}

type DropdownProps = {
  onSelect: (option?: DropdownSelectorOption) => void;
  selectedOption: DropdownSelectorOption | undefined;
  items: DropdownSelectorOption[];
  placeholder?: string;
  required?: boolean;
};

const Dropdown = ({
  onSelect,
  items,
  selectedOption,
  placeholder = "Select",
  required = false,
}: DropdownProps) => {
  const { isOpen, setIsOpen, dropdownRef, buttonRef } =
    useDropdownMenuWithOutsideClosing({
      dropdownOffset: 0,
      syncWidthWithHeader: true,
    });

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: DropdownSelectorOption) => {
    if (selectedOption?.id === option.id) {
      setIsOpen(false);
      return;
    }
    onSelect(option);
    setIsOpen(false);
  };

  const handleClearSelection = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsOpen(false);
    onSelect();
  };

  return (
    <>
      <div
        className={styles.gender_dropdown}
        onClick={handleClick}
        role="button"
        ref={buttonRef}
      >
        <div
          className={styles.dropdown_header}
          style={{
            borderWidth: isOpen ? "0.8px 0.8px 0 0.8px" : "0.8px",
            borderRadius: isOpen ? "8px 8px 0 0" : "8px",
            borderColor: isOpen ? "#F9A825" : "#3F3F3F",
          }}
        >
          <div className={styles.title}>
            {selectedOption?.title ?? placeholder}
          </div>
          {required ? (
            <Image
              className={styles.arrow}
              src={isOpen ? arrowUp : arrowDown}
              alt={"arrow"}
            />
          ) : (
            <Image
              className={styles.arrow}
              onClick={selectedOption?.id ? handleClearSelection : undefined}
              src={
                selectedOption?.id ? closeIcon : isOpen ? arrowUp : arrowDown
              }
              alt={"arrow"}
            />
          )}
        </div>
      </div>
      {isOpen &&
        createPortal(
          <div className={styles.items_wrapper} ref={dropdownRef}>
            <div className={styles.separator} />
            <div className={styles.items}>
              {items.map((item) => (
                <div
                  key={item.id}
                  className={styles.item}
                  onClick={() => handleOptionClick(item)}
                >
                  {item.title}
                </div>
              ))}
            </div>
          </div>,
          document.getElementById("open_modal") ?? document.body,
        )}
    </>
  );
};

export default Dropdown;
